// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"719fced9","455":"b3b0fdbd","977":"4172ca52"}[chunkId] + ".chunk.js";
};